module.exports = __webpack_public_path__ + "static/media/Primus_NEW_tile.a4c5b2a5.png";